import React from "react";
import { Stack, useMediaQuery } from "@mui/material";
import "./CustomTwoColInput.css";
import CustomTextInput from "../TextInput/CustomTextInput";

export interface CustomTwoColInputProps {
  firstName: string;
  lastName: string;
  placeholderOne: string;
  placeholderTwo: string;
  register: any;
  errors: any;
  disabled?: boolean;
  index?: number;
  onRemove?: (index: number) => void;
  isModalInput?: boolean;
  isRequired?: boolean;
  validationMessageFirstName?: string;
  validationMessageLastName?: string;
  patternFirstName?: { value: RegExp; message: string };
  patternLastName?: { value: RegExp; message: string };
}

const CustomTwoColInput: React.FC<CustomTwoColInputProps> = ({
  firstName,
  lastName,
  placeholderOne,
  placeholderTwo,
  register,
  errors,
  disabled,
  index,
  onRemove,
  isModalInput,
  isRequired,
  validationMessageFirstName,
  validationMessageLastName,
  patternFirstName,
  patternLastName,
}) => {
  const isMobile = useMediaQuery("(max-width:600px)");

  // バリデーションルールを動的に生成
  const firstNameValidation: Record<string, unknown> = {};
  if (isRequired) {
    firstNameValidation.required = validationMessageFirstName || "";
  }
  if (patternFirstName) {
    firstNameValidation.pattern = patternFirstName;
  }
  const lastNameValidation: Record<string, unknown> = {};
  if (isRequired) {
    lastNameValidation.required = validationMessageLastName || "";
  }
  if (patternLastName) {
    lastNameValidation.pattern = patternLastName;
  }

  return (
    <Stack
      direction="row"
      spacing={"10px"}
      className={`inputGroupWrapperWidth ${isModalInput ? "modalInput" : ""} ${
        isMobile ? "sp" : ""
      }`}
    >
      <CustomTextInput
        label=""
        name={firstName}
        placeholder={placeholderOne}
        register={(name: string) => register(name, firstNameValidation)}
        errors={errors}
        disabled={disabled}
        inputWidth="100%"
        inputWidthSp="100%"
        showRemoveButton={!!(index !== undefined && index > 0)}
        onRemoveClick={() => index !== undefined && onRemove?.(index)}
      />
      <CustomTextInput
        label=""
        name={lastName}
        placeholder={placeholderTwo}
        register={(name: string) => register(name, lastNameValidation)}
        errors={errors}
        disabled={disabled}
        inputWidth="100%"
        inputWidthSp="100%"
        showRemoveButton={!!(index !== undefined && index > 0)}
        onRemoveClick={() => index !== undefined && onRemove?.(index)}
      />
    </Stack>
  );
};

export default CustomTwoColInput;
